export const toPurchasedQuantity = (value) => {
  const quantity = Number(value);
  return Number.isFinite(quantity) ? Math.max(Math.floor(quantity), 0) : 0;
};

export const getRegistrationCommerceItems = (
  eventData,
  registration,
  checkInState = {},
) =>
  (eventData?.additionalFields || [])
    .filter(
      (field) =>
        field?.fieldType === "CommerceItem" &&
        field?.fieldName &&
        toPurchasedQuantity(registration?.[field.fieldName]) > 0,
    )
    .map((field) => {
      const quantity = toPurchasedQuantity(registration[field.fieldName]);
      const checkedUnits = checkInState?.items?.[field.fieldName]?.units || {};

      return {
        ...field,
        quantity,
        units: Array.from({ length: quantity }, (_, unitIndex) => ({
          checkedIn: Boolean(checkedUnits[String(unitIndex)]),
          unitIndex,
        })),
      };
    });

export const hasEmbeddedGuest = (registration) =>
  Boolean(
    !registration?.guestId &&
      (registration?.guestFirstName || registration?.guestLastName),
  );

export const isParticipantCheckInEligible = (status) =>
  status === "Registered" || status === "Checked-In";
